import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { TpvUserAccessRepository } from '@app/domain/ports/tpv/tpv-user-access.repository';
import { TpvUserAccess } from '@app/domain/models/tpv/tpv-user-access.model';

/** Mock del árbol de accesos TPV (`tpvUseMocks`). Refleja el ejemplo del contrato. */
@Injectable()
export class TpvUserAccessMockDataSource extends TpvUserAccessRepository {
  override getAccess(): Observable<TpvUserAccess> {
    return of<TpvUserAccess>({
      count: 1,
      companies: [
        {
          idCompany: 53,
          name: 'Empresa Prueba S.A. de C.V.',
          externalIdCompany: '019ebca6-6d2d-76a3-aff2-2141f832383d',
          units: [
            {
              externalIdUnit: '019ebca6-6dca-7fe1-9a85-c7481ca8db40',
              isPrimary: true,
              name: null,
              merchants: [
                { idMerchant: '019ec17f-5277-7423-b31b-9a09e1f59d68', name: 'Comercio Prueba A', status: 'INACTIVE' },
                { idMerchant: '019ec180-1a2b-7be4-8c0d-2e3f4a5b6c7d', name: 'Comercio Prueba B', status: 'ACTIVE' },
              ],
            },
          ],
        },
      ],
    }).pipe(delay(300));
  }
}
